import angular from 'angular';

let thumbnails = angular.module("thumbnails", ["robloxApp", "thumbnailsTemplates"]);

export default thumbnails;